import { SuperAdminModal } from '../../../baseComponents';
import { useDispatch } from 'react-redux';
import { AlertIcon } from 'src/icons';
import { useSelector } from 'react-redux';
import { deletePromptOverridesAction } from 'src/modules/SuperAdmin/store/actions/promptoverrides.action';

const DeletePromptOverrides = ({
  isOpen,
  setIsOpen,
  selectedOrganizationUUID,
  selectedCondition,
}) => {
  const dispatch = useDispatch();
  const { getPromptOverridesById } = useSelector(
    (state) => state?.promptOverrideState
  );

  const sections = [
    {
      heading: (
        <>
          <div className="flex items-center gap-2 ">
            <AlertIcon />
            Remove prompt override
          </div>
        </>
      ),
      fields: [],
    },
    {
      fields: [
        {
          type: 'label',
          title: (
            <>
              <span>Are you sure you want to remove this</span>
              <span className="font-bold ml-1">
                {getPromptOverridesById?.prompt?.description} ?
              </span>
            </>
          ),
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      className={`delete-modal`}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {
        dispatch(
          deletePromptOverridesAction(
            getPromptOverridesById?.prompt?.prompt_override_id,
            setIsOpen,
            selectedOrganizationUUID,
            selectedCondition
          )
        );
      }}
    />
  );
};

export default DeletePromptOverrides;
